import { request } from '@umijs/max';
import { UploadVo, UrlListPayload, UrlSizeListPayload } from '../ApiTypings';

export namespace ApiFile {
  /**
   * @summary 文件url列表
   * @secure
   */
  export const urlList = async (data: UrlListPayload, params: { [key: string]: any } = {}) => {
    return request<UploadVo[]>(`/api/file/url/list`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 文件url列表 [size]
   * @secure
   */
  export const urlSizeList = async (
    size: 'O' | 'L' | 'M' | 'S' | 'XS',
    data: UrlSizeListPayload,
    params: { [key: string]: any } = {},
  ) => {
    return request<UploadVo[]>(`/api/file/url/list/${size}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 文件url
   * @secure
   */
  export const url = async (id: number, params: { [key: string]: any } = {}) => {
    return request<UploadVo>(`/api/file/url/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 文件url [SIZE]
   * @secure
   */
  export const urlSize = async (
    id: number,
    size: 'O' | 'L' | 'M' | 'S' | 'XS',
    params: { [key: string]: any } = {},
  ) => {
    return request<UploadVo>(`/api/file/url/${id}/${size}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 显示文件
   * @secure
   */
  export const fileResponse = async (id: number, params: { [key: string]: any } = {}) => {
    return request<void>(`/api/file/response/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 显示文件 [SIZE]
   * @secure
   */
  export const fileResponseSize = async (
    id: number,
    size: 'O' | 'L' | 'M' | 'S' | 'XS',
    params: { [key: string]: any } = {},
  ) => {
    return request<void>(`/api/file/response/${id}/${size}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 下载文件
   * @secure
   */
  export const fileDownload = async (id: number, params: { [key: string]: any } = {}) => {
    return request<void>(`/api/file/download/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 下载文件 [SIZE]
   * @secure
   */
  export const fileDownloadSize = async (
    id: number,
    size: 'O' | 'L' | 'M' | 'S' | 'XS',
    params: { [key: string]: any } = {},
  ) => {
    return request<void>(`/api/file/download/${id}/${size}`, {
      method: 'GET',
      ...params,
    });
  };
}

export default ApiFile;

export const urlList = ApiFile.urlList;
export const urlSizeList = ApiFile.urlSizeList;
export const url = ApiFile.url;
export const urlSize = ApiFile.urlSize;
export const fileResponse = ApiFile.fileResponse;
export const fileResponseSize = ApiFile.fileResponseSize;
export const fileDownload = ApiFile.fileDownload;
export const fileDownloadSize = ApiFile.fileDownloadSize;
